import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'nordic/image';
import { misc } from '@credits-utils/constants';
import SharedPropsContext from '../../../../../../../contexts/SharedProps';

const EducationalCard = ({ data }) => {
  const { imageName, title } = data;
  const { isMobile } = React.useContext(SharedPropsContext);
  const {
    DEVICE_TYPE: { MOBILE, DESKTOP },
  } = misc;

  return (
    <div className="educational-card">
      <Image
        onload="on"
        className="educational-card__image"
        src={`buyers/educational/${`${imageName}-${isMobile ? MOBILE : DESKTOP}`}.svg`}
        alt={imageName}
      />
      <div className="educational-card__title">{title}</div>
    </div>
  );
};

EducationalCard.propTypes = {
  data: PropTypes.PropTypes.shape({
    imageName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
};

export default EducationalCard;
